import { render, staticRenderFns } from "./DRecaptcha.vue?vue&type=template&id=b9917cdc&scoped=true&"
import script from "./DRecaptcha.vue?vue&type=script&lang=js&"
export * from "./DRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9917cdc",
  null
  
)

export default component.exports